import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { CheckboxModule } from 'primeng/checkbox';
import { Router } from '@angular/router';
import { markAllControlsAsDirty, phoneOrEmailValidator } from '../../../validators/form-validation.validator';
import { AuthService } from '../../../services/auth/auth-service';
import { EmployeeService } from '../../../services/employees/employee-service';

@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule, CardModule, PasswordModule, InputTextModule, ButtonModule, CheckboxModule],
  templateUrl: './login.html',
  styleUrl: './login.scss'
})
export class Login implements OnInit {

  loginForm: FormGroup;
  isSubmitted = false

  private authService = inject(AuthService);
  private employeeService = inject(EmployeeService);
  private formBuilder = inject(FormBuilder);
  private router = inject(Router);


  ngOnInit(): void {
    this.initForm()
  }

  initForm = () => {
    this.loginForm = this.formBuilder.group({
      emailOrPhone: ['', [Validators.required, phoneOrEmailValidator]],
      password: ['', [Validators.required]],
      rememberMe: [false]
    })
  }

  login = () => {
    this.isSubmitted = true
    if (this.loginForm.invalid) {
      markAllControlsAsDirty(this.loginForm);
      return
    }

    const payload = {
      emailOrPhone: this.loginForm.value.emailOrPhone,
      password: this.loginForm.value.password,
      rememberMe: this.loginForm.value.rememberMe,
    };

    this.authService.login(payload).subscribe({
      next: (res) => {
        this.employeeService.setEmployee(res.data.employee)
        this.router.navigate([this.employeeService.getFirstAllowedRoute()]);
      }
    })
  }
}
